import type { BootstrapData, ViewerHandlers } from '../../types'
import type { IModelsAPI } from '@wix/thunderbolt-symbols'

const clientConfig = (viewerHandlers: ViewerHandlers) => {
	return {
		onRemoteChange: (cb: (name: string, value: any) => void) => {
			viewerHandlers.namedSignals.subscribe(cb)
		},
		updateRemote: (name: string, value: any) => {
			viewerHandlers.namedSignals.update(name, value)
		},
	}
}

const serverConfig = (viewerHandlers: ViewerHandlers) => {
	return {
		onRemoteChange: () => {}, // platform doesn't consume updates in ssr
		updateRemote: (name: string, value: any) => viewerHandlers.ssrSignals.updateRemote(name, value),
	}
}

export default (_: IModelsAPI, bootstrapData: BootstrapData, viewerHandlers: ViewerHandlers) => {
	const {
		platformEnvData: {
			window: { isSSR },
		},
	} = bootstrapData

	return isSSR ? serverConfig(viewerHandlers) : clientConfig(viewerHandlers)
}
